export default __webpack_public_path__ + "static/media/ve.c348a80b.svg";